import { addSpaceIfNeeded } from "../../generator-data/functions/addSpaceIfNeeded";
import { getReportSettingByKey } from "../utils/reportFunctions";

export const addHeaderToLayout = (
  section,
  newLayout,
  format,
  depth,
  newPage,
  overrideWidth,
  overrideHeight,
) => {
  if (depth === 3) {
    const ids = getReportSettingByKey("ids");

    if (ids.length <= 1) {
      return;
    }
  }

  const lastEl = addSpaceIfNeeded(
    "header",
    newLayout,
    format,
    overrideWidth,
    overrideHeight,
  );

  const currentRow = lastEl.y + lastEl.h;

  const x = 0;
  let y = currentRow;
  const w = 12;
  const h = 1;

  const spaceLeftY = format.rows - (currentRow % format.rows) - 1;
  if (depth === 1 || newPage) {
    y = currentRow + spaceLeftY + 1;
  } else if (depth !== 1 && section.includes("top-publication")) {
    if (spaceLeftY < 15) {
      y = currentRow + spaceLeftY + 1;
    }
  }

  const key = `header-${depth}-${section}`;

  newLayout.push({ i: key, x, y, w, h });
};
